module.exports = __webpack_public_path__ + "img/onboarding-user-details-illustration.51cd9a3b.svg";